"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    TeachingPopoverCarouselPageCount: function() {
        return _TeachingPopoverCarouselPageCount.TeachingPopoverCarouselPageCount;
    },
    renderTeachingPopoverCarouselPageCount_unstable: function() {
        return _renderTeachingPopoverCarouselPageCount.renderTeachingPopoverCarouselPageCount_unstable;
    },
    teachingPopoverCarouselPageCountClassNames: function() {
        return _useTeachingPopoverCarouselPageCountStylesstyles.teachingPopoverCarouselPageCountClassNames;
    },
    useTeachingPopoverCarouselPageCountStyles_unstable: function() {
        return _useTeachingPopoverCarouselPageCountStylesstyles.useTeachingPopoverCarouselPageCountStyles_unstable;
    },
    useTeachingPopoverCarouselPageCount_unstable: function() {
        return _useTeachingPopoverCarouselPageCount.useTeachingPopoverCarouselPageCount_unstable;
    }
});
const _TeachingPopoverCarouselPageCount = require("./TeachingPopoverCarouselPageCount");
const _renderTeachingPopoverCarouselPageCount = require("./renderTeachingPopoverCarouselPageCount");
const _useTeachingPopoverCarouselPageCount = require("./useTeachingPopoverCarouselPageCount");
const _useTeachingPopoverCarouselPageCountStylesstyles = require("./useTeachingPopoverCarouselPageCountStyles.styles");
